const { COUNTRIES } = require("../../constants");

const COUNTRIES_WITH_TIN_REQUIRED = [COUNTRIES.IT, COUNTRIES.ES, COUNTRIES.PT];

const getIsTINRelevantForCountry = country => {
  return COUNTRIES_WITH_TIN_REQUIRED.includes(country);
};

module.exports = { getIsTINRelevantForCountry };
